export default __webpack_public_path__ + "static/media/klicker10.89a3008c.png";